var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75L2.25 3.75V8.25C2.25 12.4125 5.13 16.305 9 17.25C12.87 16.305 15.75 12.4125 15.75 8.25V3.75L9 0.75Z",
    fill: "#0D6B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceicon);
export default __webpack_public_path__ + "static/media/insuranceicon.23213882c86b685896c36220e6a2f9ca.svg";
export { ForwardRef as ReactComponent };